<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>{{ icon }}</mat-icon></div>
    <div class="cpo-header-text">
      <h2 class="cf-dlg-title">{{ title }}</h2>
      <p class="cf-dlg-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando datos de la póliza…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="savingMessage"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="cpo-empty cpo-empty--error">
        <mat-icon>error</mat-icon>
        <span>No se pudieron cargar los datos.</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body">
      <div class="cf-dlg-mismatch" *ngIf="saveError">
        <mat-icon>error</mat-icon>
        <span>{{ saveError }}</span>
      </div>

      <span class="cf-dlg-section__label">
        {{ editing ? 'Editar registro' : 'Nuevo registro' }}
        <button *ngIf="editing" type="button" class="cpo-link" (click)="cancelEdit()">Cancelar edición</button>
      </span>

      <div class="cpo-grid">
        <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingDate">
          <app-date [control]="form.controls.fecha" [config]="fechaConfig"></app-date>
        </div>

        <ng-container *ngIf="kind === 'constitution'">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingCommission">
            <app-field [control]="form.controls.comisionApertura" [config]="comisionAperturaConfig"></app-field>
          </div>

          <div class="cf-field--required cpo-grid__wide" [class.cf-field--invalid]="submitted && missingDescription">
            <app-field [control]="form.controls.descripcion" [config]="descripcionConfig"></app-field>
          </div>
        </ng-container>

        <ng-container *ngIf="kind !== 'constitution'">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingAmount">
            <app-field [control]="form.controls.importe" [config]="importeConfig"></app-field>
          </div>

          <app-field [control]="form.controls.comisiones" [config]="comisionesConfig"></app-field>

          <div class="cf-field--required cpo-grid__wide" [class.cf-field--invalid]="submitted && missingConcept">
            <app-field [control]="form.controls.concepto" [config]="conceptoConfig"></app-field>
          </div>
        </ng-container>

        <div *ngIf="kind === 'bank'" class="cf-field--required" [class.cf-field--invalid]="submitted && missingBankAccount">
          <app-autocomplete [control]="form.controls.bankAccount" [config]="bankAccountConfig"></app-autocomplete>
        </div>

        <div *ngIf="kind === 'cash'" class="cf-field--required" [class.cf-field--invalid]="submitted && missingCash">
          <app-autocomplete [control]="form.controls.cash" [config]="cashConfig"></app-autocomplete>
        </div>

        <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingActivity">
          <app-autocomplete [control]="form.controls.activity" [config]="activityConfig"></app-autocomplete>
        </div>

        <app-autocomplete *ngIf="isProjectEnable && projects.length > 0"
          [control]="form.controls.project" [config]="projectConfig"></app-autocomplete>

        <app-autocomplete *ngIf="isProjectEnable && expenseProjectTypes.length > 0"
          [control]="form.controls.expenseProjectType" [config]="expenseProjectTypeConfig"></app-autocomplete>
      </div>

      <div class="cpo-section">
        <span class="cf-dlg-section__label">{{ itemsLabel }}</span>

        <div class="cpo-empty" *ngIf="!items.length">
          <mat-icon>info</mat-icon>
          <span>{{ emptyText }}</span>
        </div>

        <div class="cpo-items" *ngIf="items.length">
          <div class="cpo-item" *ngFor="let item of items; trackBy: trackByUid" [class.cpo-item--editing]="editing?.uid === item.uid">
            <div class="cpo-item__date">{{ item.fecha | date:'dd/MM/yyyy' }}</div>
            <div class="cpo-item__main">
              <div class="cpo-item__text">{{ itemText(item) }}</div>
              <div class="cpo-item__meta" *ngIf="itemMeta(item)">{{ itemMeta(item) }}</div>
            </div>
            <div class="cpo-item__amount">{{ (itemAmount(item) || 0) | number:'1.2-2' }} €</div>
            <div class="cpo-item__actions">
              <button mat-icon-button class="cpo-item__btn" (click)="startEdit(item)" title="Editar" aria-label="Editar">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="cpo-item__btn cpo-item__btn--danger" (click)="deleteItem(item)" title="Eliminar" aria-label="Eliminar">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="saving">
        <mat-icon>{{ editing ? 'save' : 'check_circle' }}</mat-icon> {{ editing ? 'Guardar cambios' : 'Registrar' }}
      </button>
    </div>
  </ng-container>
</div>
